import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ApprovalRequest } from 'icreate/common/models/approval-request';
import { Shipyard } from 'icreate/common/models/shipyard';
import { lastValueFrom } from 'rxjs';
import { ShipyardService } from './shipyard.service';
import { ProjectStatus, Vessel } from 'icreate/common/models/vessel';

@Injectable({
    providedIn: 'root',
})
export class PublishService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    private httpClientBackend;

    constructor(
        private http: HttpClient,
        private shipyardService: ShipyardService,
        private handler: HttpBackend
    ) {
        this.domain = EndPointApi.iApiDomain();
        this.httpClientBackend = new HttpClient(handler);
    }

    async requestPublish(approvalRequest: ApprovalRequest) {
        const payload = {
            ...approvalRequest,
            skipGuard: true,
        };
        await lastValueFrom(
            this.http.post(`${this.domain}/api/publish/approvalRequest`, payload, {
                headers: this.headers,
            })
        );
        const shipyardList: Shipyard[] = await this.shipyardService.getList();
        const shipyard = shipyardList.find(s => s.id === approvalRequest.shipyardId);

        if (shipyard) {
            shipyard.vessels.forEach((vessel, index) => {
                if (vessel.id === approvalRequest.vesselId) {
                    shipyard.vessels[index].projectStatus = ProjectStatus.PendingApproval;
                }
            });
            this.shipyardService.updateShipyardList(shipyardList);
        }
    }

    async publish(vesseliApi, shipyardiApi, version, vesselId) {
        const blobParameters = {
            vesseliApi: vesseliApi,
            shipyardiApi: shipyardiApi,
            version,
            vesselId,
            skipGuard: true,
        };
        await lastValueFrom(
            this.http.post(`${this.domain}/api/publish`, blobParameters, {
                headers: this.headers,
            })
        );
    }

    async approvePublish(publishRequestId, vesselId, approverOid) {
        await lastValueFrom(
            this.httpClientBackend.post(
                `${this.domain}/api/publish/approve`,
                { publishRequestId, vesselId, approverOid },
                {
                    headers: this.headers,
                    withCredentials: true,
                }
            )
        );
    }

    async rejectPublish(publishRequestId: string, rejectReason: string, vesselId, approverOid) {
        const body = {
            publishRequestId,
            vesselId,
            approverOid,
            rejectReason: rejectReason,
        };
        await lastValueFrom(
            this.httpClientBackend.post(`${this.domain}/api/publish/reject`, body, {
                headers: this.headers,
                withCredentials: true,
            })
        );
    }

    async removeRequest(vesselId, vesseliApi, shipyardiApi, version) {
        await lastValueFrom(
            this.httpClientBackend.post(
                `${this.domain}/api/publish/remove`,
                { vesselId, vesseliApi, shipyardiApi, version },
                {
                    headers: this.headers,
                    withCredentials: true,
                }
            )
        );
    }
}
